import { formatDate } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { LanguageService } from './services/language.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) matDateLocale: string, private languageService: LanguageService) {
    super(matDateLocale);
  }

  override format(date: Date, displayFormat: Object): string {
    const locale = this.languageService.currentLanguage;
    const dateFormat = displayFormat === 'input' ? 'dd MMMM yyyy, HH:mm' : 'MMMM yyyy';

    return formatDate(date, dateFormat, locale);
  }

  getHour(date: Date): number {
    return date.getHours();
  }

  getMinute(date: Date): number {
    return date.getMinutes();
  }

  getSecond(date: Date): number {
    return date.getSeconds();
  }

  setHour(date: Date, value: number): void {
    date.setHours(value);
  }

  setMinute(date: Date, value: number): void {
    date.setMinutes(value);
  }

  setSecond(date: Date, value: number): void {
    date.setSeconds(value);
  }

  copyTime(toDate: Date, fromDate: Date) {
    this.setHour(toDate, this.getHour(fromDate));
    this.setMinute(toDate, this.getMinute(fromDate));
    this.setSecond(toDate, this.getSecond(fromDate));
  }

  isSameTime(a: Date, b: Date): boolean {
    if (a == null || b == null) return true;
    return (
      this.getHour(a) === this.getHour(b) &&
      this.getMinute(a) === this.getMinute(b) &&
      this.getSecond(a) === this.getSecond(b)
    );
  }

  compareDateWithTime(first: Date, second: Date, showSeconds?: boolean): number {
    let res =
      super.compareDate(first, second) ||
      this.getHour(first) - this.getHour(second) ||
      this.getMinute(first) - this.getMinute(second);
    if (showSeconds) {
      res = res || this.getSecond(first) - this.getSecond(second);
    }
    return res;
  }
}
